import type { ReactNode } from 'react'

import type { ServicesDto } from '@hcr/api/optimizely'
import type { CreateCarouselOptions } from '@hcr/ui'
import { createCarousel } from '@hcr/ui'

import { createLink } from '../common'

export type CreateServicesContentOptions = Pick<CreateCarouselOptions, 'slidesMargin'>

export const createServicesContent = ({ slidesMargin }: CreateServicesContentOptions) => {
  const carousel = createCarousel({ createLink, slidesMargin })

  return (dto: ServicesDto['content'][number]): ReactNode => {
    return carousel(dto)
  }
}
